import React, { useState } from "react";
import { Tabs, Typography, Card, Tooltip, Button, Drawer, Grid,} from "antd";
import { ArrowLeftOutlined, UploadOutlined, DownloadOutlined, BankOutlined, BankTwoTone,  QuestionCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ReconciliationPage from "./components/ReconciliationPage";
import CsvUploadPage from "./components/CsvUploadPage";

const { Title } = Typography;

const BankTransactionPage = ({ authInfo }) => {
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [activeTab, setActiveTab] = useState("1");
  const [helpOpen, setHelpOpen] = useState(false);
  const HELP_CONTENT = {
  "1": {
    title: "Bank Reconciliation Help",
    content: (
      <div style={{ lineHeight: 1.8 }}>
        <h2
          style={{
            fontSize: "18px",
            fontWeight: 600,
            marginBottom: "12px",
            marginLeft: "12px"
          }}
        >
          Reconciliation List
        </h2>

        <p style={{ color: "#555", marginBottom: "16px", marginLeft:20 }}>
          The Reconciliation module is used to compare ERP bank transactions
          with bank statement records to identify unmatched or pending entries.
        </p>

        <div
          style={{
            background: "#f5f5f5",
            padding: "14px",
            borderRadius: "8px",
          }}
        >
          <strong>Available Actions</strong>

          <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>View reconciliation records</li>
            <li>Match bank statement transactions</li>
            <li>Verify debit and credit entries</li>
            <li>Track pending bank transactions</li>
            <li>Monitor reconciliation status</li>
          </ol>
        </div>
      </div>
    ),
  },

  "2": {
    title: "CSV Upload Help",
    content: (
      <div style={{ lineHeight: 1.8 }}>
        <h2
          style={{
            fontSize: "18px",
            fontWeight: 600,
            marginBottom: "12px",
            marginLeft: "10px"
          }}
        >
          Upload CSV
        </h2>

        <p style={{ color: "#555", marginBottom: "16px", marginLeft:20 }}>
          The Upload CSV module is used to import bank transaction statements
          into the ERP system for reconciliation and transaction tracking.
        </p>

        <div
          style={{
            background: "#f5f5f5",
            padding: "14px",
            borderRadius: "8px",
          }}
        >
          <strong>Available Actions</strong>

          <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>Select bank statement CSV file</li>
            <li>Upload transaction records</li>
            <li>Validate imported transaction data</li>
            <li>Review uploaded bank entries</li>
            <li>Use uploaded data for reconciliation process</li>
          </ol>
        </div>
      </div>
    ),
  },
};

  return (
    <div style={{ padding: "24px" }}>
      <div
  style={{
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
  }}
>
  <Button
    type="text"
    icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
    onClick={() => navigate(-1)}
    data-testid="bank-transactions-back-button"
  />
  <Title level={3} style={{ margin: 0 }}>
    <BankTwoTone
      twoToneColor="#595959"
      style={{ marginRight: 8 }}
    />
    Bank Transactions
  </Title>

  <div style={{ marginLeft: "auto" }}>
    <Tooltip title="Help">
      <Button
        type="text"
        icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
        onClick={() => setHelpOpen(true)}
      />
    </Tooltip>
  </div>
</div>


      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        {/* Reconciliation Tab */}
        <Tabs.TabPane tab="Reconciliation List" key="1">
          <Card>
            <ReconciliationPage authInfo={authInfo} />
          </Card>
        </Tabs.TabPane>

        {/* CSV Upload Tab */}
        <Tabs.TabPane tab="Upload CSV" key="2">
          <Card>
            <CsvUploadPage authInfo={authInfo} />
          </Card>
        </Tabs.TabPane>
      </Tabs>
      <Drawer
        title={HELP_CONTENT[activeTab]?.title}
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}

      >
        {HELP_CONTENT[activeTab]?.content}
      </Drawer>
    </div>
  );
};

export default BankTransactionPage;
